





























































import {Component, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import Terms from '@/views/public/Terms.vue';
import Privacy from '@/views/public/Privacy.vue';
import UnverifiedMembersApi from '@/apis/UnverifiedMembersApi';
import CreateUnverifiedMemberRequestModel from '@/models/unverifiedmembers/CreateUnverifiedMemberRequestModel';

@Component({
        name: 'Join',
        components: {
            Terms,
            Privacy,
        },
    },
)
export default class Join extends ViewBase {
    public givenName: string = '';
    public surname: string = '';
    public emailAddress: string = '';
    public primaryPassword1: string = '';
    public primaryPassword2: string = '';
    public backupPassword1: string = '';
    public backupPassword2: string = '';
    public agree: boolean = false;
    public showTermsDialog = false;
    public showPrivacyDialog = false;

    public givenNameRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A first name is required.';
        }

        return true;
    }

    public surnameRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A last name is required.';
        }

        return true;
    }

    public emailRules(value: string ): any {
        if ( value.trim().length === 0)
        {
            return 'An email address is required.';
        }
        else if ( value.length < 5)
        {
            return 'Minimum email address length is 5 characters.';
        }

        return true;
    }

    public primaryPassword1Rules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A primary password is required.';
        }
        else if ( value.trim().length < 8)
        {
            return 'Minimum primary password length is 8 characters.';
        }
        else if ( value.trim().toLowerCase() === this.emailAddress.toLowerCase())
        {
            return 'The primary password may not be the same as the email address you entered.';
        }

        return true;
    }

    public primaryPassword2Rules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'Please re-enter your primary password.';
        }
        else if ( value.trim() !== this.primaryPassword1)
        {
            return 'The re-entered primary password is incorrect.';
        }

        return true;
    }

    public backupPassword1Rules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A backup password is required.';
        }
        else if ( value.trim().length < 8)
        {
            return 'Minimum backup password length is 8 characters.';
        }
        else if ( value.trim().toLowerCase() === this.emailAddress.toLowerCase())
        {
            return 'The backup password may not be the same as the email address you entered.';
        }
        else if ( value.trim() === this.primaryPassword1 )
        {
            return 'The backup password may not be the same as the primary password you entered.';
        }

        return true;
    }

    public backupPassword2Rules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'Please re-enter your backup password.';
        }
        else if ( value.trim() !== this.backupPassword1)
        {
            return 'The re-entered backup password is incorrect.';
        }

        return true;
    }

    public agreeRules(value: boolean): any {
        if ( !value )
        {
            return 'You must agree to the terms and conditions and privacy policy.';
        }

        return true;
    }

    public async joinClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new CreateUnverifiedMemberRequestModel();
                request.givenName = this.givenName;
                request.surname = this.surname;
                request.emailAddress = this.emailAddress;
                request.primaryPassword = this.primaryPassword1;
                request.backupPassword = this.backupPassword1;

                const api = new UnverifiedMembersApi();
                const response = await api.createAsync(request);

                await this.$router.push({name: 'joinverify'});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.joinForm;

        return form.validate();
    }

}
